import React, { FC, ReactNode } from 'react';

import { DashboardScope } from '@api/domain/types';
import type { DashboardDrilldownFilter } from '@api/domain/types';
import { DashboardDrilldownTab } from '@v2/pages/dashboard/common/types/drilldown';

import DashboardDrilldownList from './components/DashboardDrilldownList';
import DashboardDrilldownBreakdown from './components/DashboardDrilldownBreakdown';
import DashboardDrilldownTrend from './components/DashboardDrilldownTrend';

export interface DashboardDrilldownTabbedBodyProps {
  tab: DashboardDrilldownTab;
  childScope: DashboardScope;
  drilldownFilter: DashboardDrilldownFilter;
}

const DashboardDrilldownTabbedBody: FC<DashboardDrilldownTabbedBodyProps> = ({ tab, childScope, drilldownFilter }) => {
  const tabRenderers: Record<DashboardDrilldownTab, () => ReactNode> = {
    [DashboardDrilldownTab.List]: () => (
      <DashboardDrilldownList childScope={childScope} drilldownFilter={drilldownFilter} containerStyle={{ flex: 1 }} />
    ),
    [DashboardDrilldownTab.Breakdown]: () => <DashboardDrilldownBreakdown containerStyle={{ flex: 1 }} />,
    [DashboardDrilldownTab.Trend]: () => <DashboardDrilldownTrend containerStyle={{ flex: 1 }} />,
  };

  return <>{tabRenderers[tab]()}</>;
};

export default DashboardDrilldownTabbedBody;
